// extracted by mini-css-extract-plugin
module.exports = {"title":"Customer_style_title__Q7q__","notice":"Customer_style_notice__2c5YT"};